import { AnyAction } from 'redux';
import { SET_VAULT_LOCK } from '../actions/vaultLock';

interface VaultLockState {
  isLocked: boolean;
}

const initialState: VaultLockState = {
  isLocked: false,
};

export const vaultLockReducer = (state = initialState, action: AnyAction): VaultLockState => {
  switch (action.type) {
    case SET_VAULT_LOCK:
      return {
        ...state,
        isLocked: action.payload,
      };
    default:
      return state;
  }
};
